// extracted by mini-css-extract-plugin
export default {"hero":"swiper_hero__FZKnG","container":"swiper_container__UqO+p","swiper":"swiper_swiper__vFl27","slide":"swiper_slide__qprTV","img":"swiper_img__pYPNR"};